'use strict';

const f_maybe = x => {
  const f_map = fn => f_maybe(x ? fn(x) : null);
  const f_ap = functor => functor.f_map(f => x && f ? f(x) : null);
  const f_chain = f => f(x);
  const f_result = () => x ? x : null;

  return Object.assign(f_map, { f_map, f_ap, f_chain, f_result });
};

export default f_maybe

